import EventBus from 'diagram-js/lib/core/EventBus';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import Selection from 'diagram-js/lib/features/selection/Selection';

export class SelectionBehavior {

  constructor(private eventBus: EventBus, private selection: Selection) {
    eventBus.on('commandStack.node.append.postExecuted', 500, function (e) {
      const node = e.context.node;
      const params = e.context.params;
      const nodeDetails = ModelingUtil.getNodeDetails(node);
      if (nodeDetails && nodeDetails.nodeType != NodeType.neighborhood_head) {
        if (!params || params.openPanel === true) {
          selection.select(node);
        }
      }
    });
  }
}
